/**
 * @fileoverview POSTWS handler for the "/engagement/report_builder_2/:report_id/:app_group_id/run" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryPostWebsocketAdapter } from "../reactQueryFetcherAdapters";
import { engagementReportBuilder2AppGroupIdReportIdRun } from "./constants";
import type {
  PostwsEngagementReportBuilder2AppGroupIdReportIdRunPayload,
  PostwsEngagementReportBuilder2AppGroupIdReportIdRunProps,
} from "./types";
import { isEngagementReportBuilder2ReportRunResult } from "./validators";

export const postwsEngagementReportBuilder2Run = reactQueryPostWebsocketAdapter(
  engagementReportBuilder2AppGroupIdReportIdRun,
  async (
    signal,
    {
      timeout = 180000,
      jobToken,
      ignoreCache,
      estimated,
      ...props
    }: PostwsEngagementReportBuilder2AppGroupIdReportIdRunProps
  ): Promise<{}> => {
    const payload: PostwsEngagementReportBuilder2AppGroupIdReportIdRunPayload = {
      ...props,
      timeout,
      job_token: props.reportId,
      ignore_cache: ignoreCache,
      estimated,
    };

    return fetch(`/engagement/report_builder_2/${props.reportId}/${props.appGroupId}/run`, "POST", payload, {
      signal,
    });
  },
  isEngagementReportBuilder2ReportRunResult
);
